module.exports = __webpack_public_path__ + "static/img/banner_youto_video.7ab86af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/home/imgs/head-banner/banner_youto_video.jpg
// module id = Qgtu
// module chunks = 0